const getLocationPermission = async (): Promise<boolean> => {
  try {
    const permissions =
      typeof navigator === 'undefined' ? undefined : navigator.permissions;

    if (!permissions?.query) {
      return false;
    }

    const status = await permissions.query({ name: 'geolocation' });

    return status.state === 'granted';
  } catch {
    return false;
  }
};

export default getLocationPermission;
